import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-deductions-form',
  templateUrl: './deductions-form.page.html',
  styleUrls: ['./deductions-form.page.scss']
})
export class DeductionsFormPage implements OnInit {
  zones = [
    {
        'label' : "P1 Black Zone",
        'value' : "p1",
        'price' : 55,
    },
    {
        'label' : "P2 Black Zone Premium*",
        'value' : "p2",
        'price' : 60.50,
     },
    {
        'label' : "P3 Red Zone",
        'value' : "p3",
        'price' : 25,
     },
    {
        'label' : "P4 Red Zone Premium*",
        'value' : "p4",
        'price' : 30,
     },
    {
        'label' : "P5 UMC",
        'value' : "p5",
        'price' : 25,
     },
    {
        'label' : "P6 ADA",
        'value' : "p6",
        'price' : 18,
     },
    {
        'label' : "P7 Blue Zone",
        'value' : "p7",
        'price' : 10,
     },
    {
        'label' : "P8 Silver Zone",
        'value' : "p8",
        'price' : 8,
     },
    {
        'label' : "P9 Motorcycle",
        'value' : "p9",
        'price' : 4,
     },
];
  deductionsForm: FormGroup;
  

  constructor(
    public translateService: TranslateService,
    private loaderSRV:LoaderService,
    private errorHandler: ErrorHandlerService,
    private router:Router,
    private toastSRV:ToastService,
    public dataSRV: DataService,
    private fb: FormBuilder) {}

  ngOnInit() {
    this.initializeForm();
    
    
  }

  initializeForm() {
    this.deductionsForm = this.fb.group({
      spriden_id: ['', Validators.required],
      status: ['', Validators.required],
      electric_vehicle: ['', Validators.required],
      employee_deduction_consent: ['', Validators.required],
      employee_consent_date: ['',Validators.required],
      // department_received_date: ['',Validators.required],
      // department_received_confirm: ['',Validators.required],
      // zone:['', Validators.required],
      ph_tax: this.fb.array([]),
    });
    const initialValues = []; // Example: Pre-check PH1 and PH2
    const phTaxArray = this.deductionsForm.get('ph_tax') as FormArray;
    initialValues.forEach((value) => phTaxArray.push(this.fb.control(value)));
    this.deductionsForm.valueChanges.subscribe((formValues) =>{
      if (formValues.department_received_date) {
        const formattedDate = this.formatDate(formValues.department_received_date);
        // Update the form control with the formatted date
        this.deductionsForm.patchValue(
          { department_received_date: formattedDate },
          { emitEvent: false } // Prevent triggering valueChanges again
        );
      }
      if (formValues.employee_consent_date) {
        const formattedDate = this.formatDate(formValues.employee_consent_date);
        // Update the form control with the formatted date
        this.deductionsForm.patchValue(
          { employee_consent_date: formattedDate },
          { emitEvent: false } // Prevent triggering valueChanges again
        );
      }
    } );
  }
  async openPDF(url){
    await Browser.open({ url: url });
  }
  onCheckboxChange(event: any, value: string) {
    const phTaxArray = this.deductionsForm.get('ph_tax') as FormArray;
  
    if (event.detail.checked) {
      // Add value to the FormArray if the checkbox is checked
      phTaxArray.push(this.fb.control(value));
    } else {
      // Remove value from the FormArray if the checkbox is unchecked
      const index = phTaxArray.controls.findIndex((ctrl) => ctrl.value === value);
      if (index > -1) {
        phTaxArray.removeAt(index);
      }
    }
  }
  
  onSubmit() {
    this.loaderSRV.showLoader((this.translateService.instant('keys.data.common.loading') || 'Loading...'))
    if (this.deductionsForm.valid) {
      this.dataSRV.postData('custom_form/ttu/miscellaneous_deductions/submit',this.deductionsForm.value).subscribe({
        next:(data:any)=>{
          this.loaderSRV.dismissLoader()
          if(data.status=='success'){
            this.toastSRV.presentToast(data?.message);
            this.initializeForm()
            this.router.navigateByUrl('home')
          } else {
            this.errorHandler.displayErrorMessage(data, true)
          }
        },
        error:err=>{
          this.errorHandler.displayErrorMessage(err, true)
        }
      })
    } else {
      console.error('Form is invalid');
    }
  }
  formatDate(date: string): string {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return format(parsedDate, 'yyyy/MM/dd'); // Using date-fns to format date
    }
    return date; // Return the original value if the date is invalid
  }
}
